import React, { useState, useEffect } from 'react';
import Register from '../Popups/Register';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../Popups/login.css';

const Homepage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  // Toggle popup function
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // Close notification function
  const closeNotification = () => {
    setShowNotification(false);
    localStorage.setItem('notificationInteracted', 'true');
  };

  // Handle redirection to the period tracker and store interaction
  const handleTryNow = () => {
    window.location.href = '/period-tracker';
    localStorage.setItem('notificationInteracted', 'true');
  };

  // Initialize carousel and handle notification logic
  useEffect(() => {
    const bootstrap = require('bootstrap');

    // Programmatically initialize carousel with an interval of 4000ms (4 seconds)
    const carouselElement = document.getElementById('carouselExample');
    const carousel = new bootstrap.Carousel(carouselElement, {
      interval: 4000, // Set interval to 4 seconds
      ride: 'carousel'
    });

    // Check whether to show notification based on localStorage
    const checkNotificationDisplay = () => {
      const interacted = localStorage.getItem('notificationInteracted');
      if (!interacted) {
        setShowNotification(true);
      }
    };

    checkNotificationDisplay();

    // Clear localStorage before page unloads
    const handleBeforeUnload = () => {
      localStorage.removeItem('notificationInteracted');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <div className='home'>
      {/* Bootstrap 5 Carousel with Fading Effect */}
      <div id="carouselExample" className="carousel slide carousel-fade" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="carousel-item-wrapper">
              <a href="#">
                <img src="/homepage/1.png" className="d-block w-100" alt="First slide" />
              </a>
            </div>
          </div>
          <div className="carousel-item">
            <div className="carousel-item-wrapper">
              <a href="#">
                <img src="/homepage/2.png" className="d-block w-100" alt="Second slide" />
              </a>
            </div>
          </div>
          <div className="carousel-item">
            <div className="carousel-item-wrapper">
              <a href="/labtests">
                <img src="/homepage/3.png" className="d-block w-100" alt="Third slide" />
              </a>
            </div>
          </div>
          <div className="carousel-item">
            <div className="carousel-item-wrapper">
              <a href="/doctors">
                <img src="/homepage/4.png" className="d-block w-100" alt="Fourth slide" />
              </a>
            </div>
          </div>
          <div className="carousel-item">
            <div className="carousel-item-wrapper">
              <a href="/medicines">
                <img src="/homepage/5.png" className="d-block w-100" alt="Fifth slide" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className='services'>
        <div className='ser-inside'>
          <a href='/oxygencylinder' style={{ textDecoration: 'none' }} className='ser-card'>
            <div className='img img1'>
              <img src='/labtest/oxy.png' alt='' className='move-right-1' />
            </div>
            <div className='down'>
              <div className='title'>Find Oxygen Near You</div>
              <span style={{ textDecoration: 'none', all: 'unset' }} className='sp-link'>
                Oxygen in Emergency
              </span>
            </div>
          </a>
          <a href='/doctors' style={{ textDecoration: 'none' }} className='ser-card'>
            <div className='img img2'>
              <img src='/homepage/serv/dr.png' alt='' className='zoom-out move-down' />
            </div>
            <div className='down'>
              <div className='title'>Find Doctors Near You</div>
              <span style={{ textDecoration: 'none', all: 'unset' }} className='sp-link'>
                Every Specialists You Want
              </span>
            </div>
          </a>
          <a style={{ textDecoration: 'none' }} href='/bloodbank' className='ser-card'>
            <div className='img img3'>
              <img src='/homepage/serv/ab.png' alt='' className='move-right-2 zoom-in-2' />
            </div>
            <div className='down'>
              <div className='title'>Find Blood Bank</div>
              <span style={{ textDecoration: 'none', all: 'unset' }} className='sp-link'>
                At Fastest
              </span>
            </div>
          </a>
          <a style={{ textDecoration: 'none' }} href='/medicines' className='ser-card'>
            <div className='img img4'>
              <img src='/homepage/serv/del2.png' alt='' className='move-right' />
            </div>
            <div className='down'>
              <div className='title'>Find Medicines Near You</div>
              <span style={{ textDecoration: 'none', all: 'unset' }} className='sp-link'>
                Essentials at Your Doorstep
              </span>
            </div>
          </a>
        </div>
      </div>

         {/* Specialities Section */}
      <div className="specialities">
        <div className="spe-inside">
          {/* View All Specialities Button */}
          <div className="up">
            <div className="heading">
            Get Expert Medical Advice Online for Any Health Concerns <br />{" "}
              <span>
              Private Access to Verified Doctors for Online Consultations Across All Specialties
              </span>
            </div>
            <a href="/hospitals" className="view-sp">
            See All Specialties
            </a>
          </div>

          {/* Infinite Moving Strap */}
          <div className="speciality-strap">
            <div className="scrolling-content">
              {/* Original Set of Specialties */}
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/preg.png" alt="Periods or Pregnancy" />
                </div>
                <div className="title">Women's Health : Periods & Pregnancy</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/acne.png" alt="Acne" />
                </div>
                <div className="title">Skin Health : Acne & Pimples Solutions</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/performance.png" alt="Strength" />
                </div>
                <div className="title">Sexual Strength :  Vitality Issues</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/cold.png" alt="Cold" />
                </div>
                <div className="title">Health Concerns : Cough, Cold & Fever</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/baby.png" alt="Not Feeling Well" />
                </div>
                <div className="title">Children's Health : Common Illness</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/depression.png" alt="Depression" />
                </div>
                <div className="title">Mental Health : Depression & Anxiety</div>
              </div>

              {/* Duplicate the set to make the scroll seamless */}
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/preg.png" alt="Periods or Pregnancy" />
                </div>
                <div className="title">Women's Health : Periods & Pregnancy</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/acne.png" alt="Acne" />
                </div>
                <div className="title">Skin Health : Acne & Pimples Solutions</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/performance.png" alt="Strength" />
                </div>
                <div className="title">Sexual Strength : Vitality Issues</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/cold.png" alt="Cold" />
                </div>
                <div className="title">Health Concerns : Cough, Cold & Fever</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/baby.png" alt="Not Feeling Well" />
                </div>
                <div className="title">Children's Health : Common Illness</div>
              </div>
              <div className="sp-card">
                <div className="img">
                  <img src="/material/health/depression.png" alt="Depression" />
                </div>
                <div className="title">Mental Health : Depression & Anxiety</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Popup */}
      {showNotification && (
        <div className='notification-overlay'>
          <div className='notification-popup'>
            <button className='close-btn' onClick={closeNotification}>
              &times;
            </button>
            <h2>Try Our New Period Tracker!</h2>
            <p>Stay on top of your health with our new feature.</p>
            <button className='try-now-btn' onClick={handleTryNow}>
              Try Now
            </button>
          </div>
        </div>
      )}

      {/* Registration Popup */}
      {isOpen && (
        <div className='pop-overlay'>
          <div className='pr'>
            <Register />
            <button className='cls-btn c-r cr' onClick={togglePopup}>
              <i className='fa-solid fa-xmark'></i>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Homepage;
